export class GCSRestoreDestination {
    'bucketName';
    'prefix';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GCSRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
